import { render, staticRenderFns } from "./SpecificationAdd.vue?vue&type=template&id=6956dcaa&"
import script from "./SpecificationAdd.vue?vue&type=script&lang=js&"
export * from "./SpecificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports